export const translations = {
    en: {
        "dashboard": "Dashboard",
        "orders": "Orders",
        "products": "Products",
        "lifestyle_needs": "Lifestyle & Needs",
        "lang_en": "English",
        "lang_ta": "Tamil",
        "settings": "Settings",
        "profile": "Profile",
        "logout": "Logout",
        "logout_title": "Wait, Are You Leaving?",
        "logout_description": "We're sad to see you go. Are you sure you want to sign out of your current session?",
        "stay_here": "Stay Here",
        "sign_out": "Sign Out",
        "login": "Login",
        "signup": "Sign Up",
        "search": "Search",
        "filter": "Filter",
        "actions": "Actions",
        "edit": "Edit",
        "delete": "Remove",
        "update": "Update",
        "save": "Save",
        "cancel": "Cancel",
        "operation_failed": "Operation failed",
        "manage_language": "Manage Language",
        "add_language": "Add Language",
        "edit_language": "Edit Language",
        "manage_currency": "Manage Currency",
        "symbol": "Symbol",
        "exchange_rate": "Exchange Rate",
        "currency_name": "Currency Name",
        "add_currency": "Add Currency",
        "edit_currency": "Edit Currency",
        "set_default_currency": "Set as Default Currency",
        "please_enter_symbol": "Please enter symbol",
        "please_enter_rate": "Please enter rate",
        "confirm_delete_currency": "Remove this currency?",
        "currency_deleted": "Currency removed successfully",
        "failed_delete_currency": "Failed to remove currency",
        "currency_updated": "Currency updated successfully",
        "currency_added": "Currency added successfully",
        "language_name_placeholder": "E.g. English",
        "language_code_placeholder": "E.g. en",
        "currency_name_placeholder": "E.g. US Dollar",
        "currency_code_placeholder": "E.g. USD",
        "currency_symbol_placeholder": "E.g. $",
        "cannot_deactivate_default": "Cannot deactivate default",
        "set_another_default_first": "Please set another language as default first.",
        "status_updated": "Status updated successfully",
        "activate_before_default": "Language must be active before setting it as default",
        "default_language_updated": "Default language updated successfully",
        "cannot_deactivate_default_currency": "Cannot deactivate default currency",
        "default_currency_updated": "Default currency updated successfully",
        "status": "Status",
        "buyer": "Buyer",
        "admin": "Admin",
        "seller": "Seller",
        "super_admin": "Super Admin",
        "admin_panel": "Admin Panel",
        "seller_panel": "Seller Panel",
        "addresses": "Addresses",
        "returns": "Returns",
        "rewards": "Rewards",
        "points": "Points",
        "offers": "Offers",
        "wishlist": "Wishlist",
        "support": "Support",
        "categories": "Categories",
        "sub_categories": "Sub Categories",
        "child_categories": "Child Categories",

        "brands": "Brands",
        "home": "Home",
        "navigation": "Navigation",
        "sales": "Sales",
        "account": "Account",
        "reports": "Reports",
        "language": "Language",
        "currency": "Currency",
        "users": "Users",
        "product_management": "Product Management",
        "shop_management": "Shop Management",
        "user_management": "User Management",
        "marketing": "Marketing",
        "coupons": "Coupons",
        "profile_settings": "Profile Settings",
        "admin_permissions": "Admin Permissions",
        "delivery_management": "Delivery Management",
        "delivery_address": "Delivery Address",
        "import_export": "Import & Export",
        "sales_reports": "Sales Reports",
        "product_reports": "Product Reports",
        "shop_setup": "Shop Setup",
        "product_setup": "Product Setup",
        "shop_settings": "Shop Settings",
        "product_options": "Product Options",
        "products_sold": "Products Sold",
        "inventory_update": "Inventory Update",
        "cod_instructions": "COD Instructions",
        "deliveries": "Deliveries",
        "delivery_settings": "Delivery Settings",
        "delivery_staff": "Delivery Staff",
        "delivery_staff_fee": "Delivery Staff Fee",
        "invoices": "Invoices",
        "import_data": "Import Data",
        "export_data": "Export Data",
        "messages": "Messages",
        "returns_refunds": "Returns & Refunds",
        "seller_investors": "Seller Investors",
        "product_tags": "Product Tags",
        "product_feedback": "Product Feedback",
        "inventory_thresholds": "Inventory Thresholds",
        "seller_requests": "Seller Requests",
        "buyer_dashboard": "Buyer Dashboard",
        "my_orders": "My Orders",
        "cancellations": "Cancellations",
        "return_requests": "Return Requests",
        "personal_info": "Personal Info",
        "my_addresses": "My Addresses",
        "security": "Security",
        "reward_points": "Reward Points",
        "share_earn": "Share & Earn",
        "order_id": "Order ID",
        "date": "Date",
        "scheduled": "Scheduled",
        "action": "Action",
        "view": "View",
        "my_offers": "My Offers",
        "my_credits": "My Credits",
        "notifications": "Notifications",
        "contact_us": "Contact Us",
        "view_all": "View All",
        "no_notifications": "No new notifications",
        "shop": "Shop",
        "category": "Category",
        "brand": "Brand",
        "user": "User",
        "customer": "Customer",
        "delivery": "Delivery",
        "product": "Product",
        "price": "Price",
        "total": "Total",
        "amount": "Amount",
        "revenue": "Revenue",
        "credits": "Credits",
        "wallet": "Wallet",
        "name": "Name",
        "code": "Code",
        "default": "Default",
        "system_default": "System Default",
        "system_default_tooltip": "Default for new users and guest visitors",
        "standard": "Standard",
        "language_name": "Language Name",
        "language_code": "Language Code",
        "set_default_language": "Set as Default Language",
        "active_status_label": "Active Status",
        "please_enter_name": "Please enter name",
        "please_enter_code": "Please enter code",
        "confirm_delete_language": "Remove this language?",
        "language_deleted": "Language removed successfully",
        "failed_delete_language": "Failed to remove language",
        "language_updated": "Language updated successfully",
        "language_added": "Language added successfully",
        "pending": "Pending",
        "approved": "Approved",
        "rejected": "Rejected",
        "active": "Active",
        "inactive": "Inactive",
        "active_status": "Active",
        "processing": "Processing",
        "shipped": "Shipped",
        "delivered": "Delivered",
        "cancelled": "Cancelled",
        "ordered": "Ordered",
        "packed": "Packed",
        "completed": "Completed",
        "return_requested": "Return Requested",
        "return_picked_up": "Picked Up",
        "returned": "Returned",
        "refund_completed": "Refund Completed",
        "delivery_missed": "Delivery Missed",
        "more_items": "More items",
        "success": "Success",
        "error": "Error",
        "confirm_delete": "Are you sure you want to delete?",
        "no_data": "No Data Found",
        "loading": "Loading...",
        "welcome": "Welcome",
        "application_status": "Application Status",
        "latest_orders": "Latest Orders",
        "available_balance": "Available Balance",
        "credited_today": "Credited Today",
        "order_stats": "Order Stats",
        "today_orders": "Today's Orders",
        "unread_notification": "Unread Notification",
        "invite_friends": "Invite your friends!",
        "share_referral_text": "Share your unique referral code with friends and family. Earn points when they sign up and make their first purchase.",
        "copy": "Copy",
        "share": "Share",
        "no_record_found": "No record found",
        "address": "Address",
        "track_returns": "Track return requests here.",
        "check_later": "Please check back later.",
        "return_status": "Return Status",
        "reason": "Reason",
        "seller_comment": "Seller Comment",
        "request_summary": "Request Summary",
        "refund_value": "Refund Value",
        "submitted": "Submitted",
        "requested_items": "Requested Items",
        "quantity": "Quantity",
        "close": "Close",
        "return_details": "Return Request Details",
        "request_id": "Request ID",
        "sales_overview": "Monthly Sales Overview",
        "live_data": "Live Data",
        "no_recent_orders": "No recent orders",
        "total_shops": "Total Shops",
        "total_products": "Total Products",
        "recent_orders_card": "Recent Orders",
        "monthly_comparison": "Monthly performance comparison with last quarter",
        "current_month": "Current Month",
        "last_month": "Last Month",
        "quarter_target": "Quarter Target",
        "growth": "Growth",
        "decline": "Decline",
        "compared_to_last_month": "Compared to last month",
        "delivery_missed_title": "Delivery Missed – Awaiting Action",
        "delivery_missed_text": "We missed your scheduled delivery window. Please choose a new time slot or cancel the order for an instant full refund.",
        "reschedule_now": "Reschedule Now",
        "cancel_refund": "Cancel & Refund",
        "edit_profile": "Edit Profile",
        "nearzon_user": "Nearzon User",
        "personal_info_tab": "Personal Info",
        "my_addresses_tab": "My Addresses",
        "profile_settings_tab": "Profile Settings",
        "full_name": "Full Name",
        "email_address": "Email Address",
        "phone_number": "Phone Number",
        "joined_nearzon": "Joined on Nearzon",
        "credit_balance": "Credit Balance",
        "saved_addresses": "Saved Addresses",
        "add_address_btn": "Add Address",
        "add_new_address_btn": "Add New Address",
        "security_settings": "Security Settings",
        "change_password": "Change Password",
        "privacy_settings": "Privacy Settings",
        "notification_settings": "Notifications",
        "edit_personal_info": "Edit Personal Information",
        "save_changes": "Save Changes",
        "first_name": "First Name",
        "last_name": "Last Name",
        "email_unchangeable": "Email cannot be changed.",
        "update_profile_pic": "Update Profile Picture",
        "select_new_photo": "Select New Photo",
        "upload_save": "Upload & Save",
        "current_password": "Current Password",
        "new_password": "New Password",
        "confirm_new_password": "Confirm New Password",
        "passwords_do_not_match": "Passwords do not match!",
        "show_profile_public": "Show Profile to Public",
        "show_email_address": "Show Email Address",
        "show_phone_number": "Show Phone Number",
        "email_notifications": "Email Notifications",
        "order_status_updates": "Order Status Updates",
        "promotional_emails": "Promotional Emails",
        "edit_address": "Edit Address",
        "add_new_address": "Add New Address",
        "address_type": "Address Type",
        "street": "Street",
        "city_taluk": "City/Taluk",
        "district": "District",
        "pincode": "Pincode",
        "home_label": "Home",
        "office_label": "Office",
        "pickup_label": "Pickup",
        "billing_label": "Billing",
        "other_label": "Other",
        "not_provided": "Not provided",
        "na": "N/A",
        "retry": "Retry",
        "security_config": "Security Configuration",
        "manage_security_desc": "Manage your password and security questions.",
        "no_addresses_found": "No addresses found",
        "available_credits_label": "Available Credits",
        "total_earned": "Total Earned",
        "total_spent": "Total Spent",
        "bonus_credits": "Bonus Credits",
        "refunds": "Refunds",
        "transaction_history": "Transaction History",
        "no_transactions_yet": "No transactions yet",
        "times_count": "Times",
        "description": "Description",
        "type": "Type",
        "mark_all_read": "Mark all as read",
        "no_wishlist_msg": "Your wishlist is empty",
        "my_wishlist": "My Wishlist",
        "remove": "Remove",
        "order_now": "Order Now",
        "cart": "Cart",
        "enter_first_name": "Please enter first name",
        "enter_last_name": "Please enter last name",
        "enter_street": "Please enter street address",
        "enter_pincode": "Please enter pincode",
        "select_addr_type": "Select address type",
        "enter_custom_label": "Enter custom label",
        "label_eg_school": "Label (e.g. School, Gym)",
        "label_eg_warehouse": "Label (e.g. Warehouse)",
        "enter_curr_pass": "Enter current password",
        "enter_new_pass": "Enter new password",
        "confirm_new_pass": "Confirm new password",
        "pass_min_6": "Password must be at least 6 characters",
        "please_enter_curr_pass": "Please enter your current password",
        "please_enter_new_pass": "Please enter your new password",
        "please_confirm_new_pass": "Please confirm your new password",
        "security_settings_loaded": "Security settings loaded.",
        "error_loading_profile": "Failed to load profile",
        "error_loading_addresses": "Failed to load addresses",
        "error_removing_address": "Failed to remove address",
        "address_removed": "Address removed",
        "address_updated": "Address updated",
        "address_added": "Address added",
        "error_saving_address": "Failed to save address",
        "transactions": "Transactions",
        "profile_updated_success": "Profile updated successfully",
        "error_updating_profile": "Failed to update profile",
        "invalid_file": "Invalid File",
        "invalid_file_desc": "You can only upload JPG/PNG/WEBP files!",
        "file_too_large": "File Too Large",
        "file_too_large_desc": "Image must be smaller than 2MB!",
        "profile_image_updated": "Profile image updated",
        "image_upload_failed": "Image upload failed",
        "password_updated_success": "Password updated successfully",
        "error_updating_password": "Failed to update password",
        "privacy_settings_updated": "Privacy settings updated",
        "error_updating_privacy": "Failed to update privacy settings",
        "notify_settings_updated": "Notification preferences updated",
        "error_updating_notify": "Failed to update notification settings",
        "address_removed_success": "Address removed successfully",
        "addresses_updated_success": "Addresses updated successfully",
        "change_password_desc": "Secure your account with a strong password",
        "privacy_settings_desc": "Control your visibility and data",
        "notification_settings_desc": "Manage your alert preferences",
        "today_hot_deals": "Today's Hot Deals",
        "weekly_hot_deals": "More Hot Deals",
        "filters": "Filters",
        "shop_name": "Shop Name",
        "zipcode": "Zipcode",
        "shops": "Shops",
        "view_shop": "View Shop",
        "less": "Less",
        "more": "More",
        "products_you_may_like": "Products You May Like",
        "shops_within": "Shops within",
        "weekly_deals": "Today's Deals",
        "recipes": "Recipes",
        "user_login": "User Login",
        "search_placeholder": "Search products and stores",
        "choose_location": "Choose Location",
        "under_review": "Under Review",
        "appearance": "Appearance",
        "my_account": "My Account",
        "my_wallet": "My Wallet",
        "start_selling": "Start Selling",
        "off": "OFF",
        "select_option": "Select Option",
        "add": "Add",
        "buy_now": "Buy Now",
        "in_stock": "In Stock",
        "out_of_stock": "Out of Stock",
        "login_required": "Continue Shopping",
        "login_to_add_to_cart_desc": " Login to continue your shopping journey with Nearzon.",
        "login_to_proceed_checkout_desc": "Experience the best of Nearzon. Please login to proceed with checkout.",
        "all_categories": "All Categories",
        "quick_links": "Quick Links",
        "get_in_touch": "Get in Touch",
        "newsletter": "Newsletter",
        "newsletter_desc": "Subscribe to receive the latest offers and updates.",
        "all_rights_reserved": "All rights reserved.",
        "all_categories_desc": "Explore everything Nearzon has to offer across our marketplace.",
        "view_products": "View Products",
        "explore_range": "Explore our wide range of",
        "verified_sellers": "from verified local sellers.",
        "all_products": "All Products",
        "track_order": "Track Order",
        "help_center": "Help Center",
        "feedback": "Feedback",
        "email": "Enter your email address",
        "no_shops_found": "No shops found matching your criteria.",
        "fresh_products_daily": "Fresh products daily",
        "nearzon_marketplace": "Nearzon Marketplace",
        "inspired_by_browsing": "Inspired by your browsing history",
        "refresh": "Refresh",
        "reset_all": "Reset All",
        "rating": "Rating",
        "price_range": "Price Range",
        "shop_by_categories": "Shop by Categories",
        "order_details": "Order Details",
        "cancel_order_btn": "Cancel Order",
        "reschedule_delivery_btn": "Reschedule Delivery",
        "return_order_btn": "Return Order",
        "reorder_btn": "Re-Order",
        "order_info": "Order Info",
        "price_summary": "Price Summary",
        "items_subtotal": "Items Subtotal",
        "delivery_charges": "Delivery Charges",
        "total_order_value": "Total Order Value",
        "wallet_credits_used": "Wallet Credits Used",
        "cod_payable_amount": "COD Payable Amount",
        "amount_paid": "Amount Paid",
        "reason_for_cancellation": "Reason for cancellation",
        "ordered_by_mistake": "Ordered by mistake",
        "found_better_price": "Found a better price",
        "delivery_too_long": "Delivery time is too long",
        "changed_my_mind": "Changed my mind",
        "other": "Other",
        "request_return": "Request Return",
        "return_item": "Return Item",
        "select_reason_for_return": "Select a reason for return",
        "dont_like_product": "I don't like the product",
        "wrong_item_received": "Wrong item received",
        "quality_issue": "Quality issue",
        "better_price_available": "Better price available",
        "ordered_by_mistake_return": "Ordered by mistake",
        "other_reason": "Other reason",
        "confirm_return": "Confirm Return",
        "cancel_refund_btn": "Cancel & Refund",
        "confirm_cancel": "Yes, Cancel Order",
        "confirm_cancel_msg": "Are you sure you want to cancel this order?",
        "standard_delivery": "Standard Delivery",
        "delivery_within_24h": "The delivery will be completed within 24 hours.",
        "delivery_by_tomorrow": "The delivery will be completed by tomorrow.",
        "delivery_by_date": "The delivery will be completed by {date}.",
        "today": "Today",
        "failed_save_address": "Failed to save address",
        "no_profile_data": "No profile data found. Please check your connection.",
        "items": "Items",
        "submit": "Submit Return Request",
        "delivery_time_change_requested": "Delivery Time Change Requested",
        "seller_requested_time_change": "The seller has requested to change the delivery time to:",
        "approve": "Approve",
        "reject": "Reject",
        "adjust_filters_desc": "Try adjusting your filters or search terms",
        "clear_all_filters": "Clear All Filters",
        "order_history": "Order History",
        "active_tracking": "Active Tracking",
        "current_orders": "Current Orders",
        "drawer_info_text": "Showing items that are currently in progress. Once delivered, they will move to your order history.",
        "no_delivered_orders": "No delivered orders found.",
        "other_orders": "Cancellations & Returns",
        "crop_image": "Crop Image",
        "zoom_label": "Zoom",
        "crop_failed": "Failed to crop image"
    },
    ta: {
        "dashboard": "டாஷ்போர்டு",
        "orders": "ஆர்டர்கள்",
        "sales": "விற்பனை",
        "account": "கணக்கு",
        "reports": "அறிக்கைகள்",
        "products": "தயாரிப்புகள்",
        "lang_en": "ஆங்கிலம்",
        "lang_ta": "தமிழ்",
        "settings": "அமைப்புகள்",
        "profile": "சுயவிவரம்",
        "logout": "வெளியேறு",
        "logout_title": "காத்திருங்கள், நீங்கள் வெளியேறுகிறீர்களா?",
        "logout_description": "நீங்கள் செல்வதைக் கண்டு நாங்கள் வருந்துகிறோம். உங்கள் தற்போதைய அமர்விலிருந்து வெளியேறுவதில் உறுதியாக இருக்கிறீர்களா?",
        "stay_here": "இங்கேயே இருங்கள்",
        "sign_out": "வெளியேறு",
        "login": "உள்நுழை",
        "signup": "பதிவு செய்",
        "search": "தேடு",
        "filter": "வடிகட்டி",
        "actions": "செயல்கள்",
        "edit": "திருத்து",
        "delete": "அழி",
        "update": "புதுப்பிப்பு",
        "save": "சேமி",
        "cancel": "ரத்துசெய்",
        "operation_failed": "செயல்பாடு தோல்வியுற்றது",
        "manage_language": "மொழியை நிர்வகி",
        "add_language": "மொழியைச் சேர்",
        "edit_language": "மொழியைத் தொகு",
        "manage_currency": "நாணயத்தை நிர்வகி",
        "symbol": "சின்னம்",
        "exchange_rate": "மாற்று விகிதம்",
        "currency_name": "நாணய பெயர்",
        "add_currency": "நாணயத்தைச் சேர்",
        "edit_currency": "நாணயத்தைத் தொகு",
        "set_default_currency": "இயல்புநிலை நாணயமாக அமை",
        "please_enter_symbol": "தயவுசெய்து சின்னத்தை உள்ளிடவும்",
        "please_enter_rate": "தயவுசெய்து விகிதத்தை உள்ளிடவும்",
        "confirm_delete_currency": "இந்த நாணயத்தை நீக்கவா?",
        "currency_deleted": "நாணயம் வெற்றிகரமாக நீக்கப்பட்டது",
        "failed_delete_currency": "நாணயத்தை நீக்குவதில் தோல்வி",
        "currency_updated": "நாணயம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
        "currency_added": "நாணயம் வெற்றிகரமாக சேர்க்கப்பட்டது",
        "language_name_placeholder": "எ.கா. ஆங்கிலம்",
        "language_code_placeholder": "எ.கா. en",
        "currency_name_placeholder": "எ.கா. அமெரிக்க டாலர்",
        "currency_code_placeholder": "எ.கா. USD",
        "currency_symbol_placeholder": "எ.கா. $",
        "cannot_deactivate_default": "இயல்புநிலை மொழியை முடக்க முடியாது",
        "set_another_default_first": "தயவுசெய்து முதலில் மற்றொரு மொழியை இயல்புநிலையாக அமைக்கவும்.",
        "status_updated": "நிலை வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
        "activate_before_default": "இயல்புநிலையாக அமைப்பதற்கு முன் மொழி செயலில் இருக்க வேண்டும்",
        "default_language_updated": "இயல்புநிலை மொழி வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
        "cannot_deactivate_default_currency": "இயல்புநிலை நாணயத்தை முடக்க முடியாது",
        "default_currency_updated": "இயல்புநிலை நாணயம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
        "status": "நிலை",
        "buyer": "வாங்குபவர்",
        "admin": "நிர்வாகி",
        "seller": "விற்பனையாளர்",
        "super_admin": "சூப்பர் நிர்வாகி",
        "admin_panel": "நிர்வாகக் குழு",
        "seller_panel": "விற்பனையாளர் குழு",
        "addresses": "முகவரிகள்",
        "returns": "திரும்பியவை",
        "rewards": "வெகுமதிகள்",
        "points": "புள்ளிகள்",
        "offers": "சலுகைகள்",
        "wishlist": "விருப்பப்பட்டியல்",
        "support": "ஆதரவு",
        "categories": "வகைகள்",
        "sub_categories": "துணை வகைகள்",
        "child_categories": "குழந்தை வகைகள்",

        "brands": "பிராண்டுகள்",
        "home": "முகப்பு",
        "navigation": "வழிசெலுத்தல்",
        "language": "மொழி",
        "currency": "நாணயம்",
        "users": "பயனர்கள்",
        "product_management": "தயாரிப்பு மேலாண்மை",
        "shop_management": "கடை மேலாண்மை",
        "user_management": "பயனர் மேலாண்மை",
        "marketing": "சந்தைப்படுத்தல்",
        "coupons": "கூப்பன்கள்",
        "profile_settings": "சுயவிவர அமைப்புகள்",
        "admin_permissions": "நிர்வாகி அனுமதிகள்",
        "delivery_management": "டெலிவரி மேலாண்மை",
        "delivery_address": "டெலிவரி முகவரி",
        "import_export": "இறக்குமதி மற்றும் ஏற்றுமதி",
        "sales_reports": "விற்பனை அறிக்கைகள்",
        "product_reports": "தயாரிப்பு அறிக்கைகள்",
        "shop_setup": "கடை அமைப்பு",
        "product_setup": "தயாரிப்பு அமைப்பு",
        "shop_settings": "கடை அமைப்புகள்",
        "product_options": "தயாரிப்பு விருப்பங்கள்",
        "products_sold": "விற்கப்பட்ட தயாரிப்புகள்",
        "inventory_update": "சரக்கு இருப்பு புதுப்பிப்பு",
        "cod_instructions": "சிஓடி அறிவுறுத்தல்கள்",
        "deliveries": "டெலிவரிகள்",
        "delivery_settings": "டெலிவரி அமைப்புகள்",
        "delivery_staff": "டெலிவரி பணியாளர்கள்",
        "delivery_staff_fee": "டெலிவரி பணியாளர் கட்டணம்",
        "invoices": "இன்வாய்ஸ்கள்",
        "import_data": "தரவை இறக்குமதி செய்",
        "export_data": "தரவை ஏற்றுமதி செய்",
        "messages": "செய்திகள்",
        "returns_refunds": "திரும்பியவை மற்றும் பணத்தைத் திரும்பப் பெறுதல்",
        "seller_investors": "விற்பனையாளர் முதலீட்டாளர்கள்",
        "product_tags": "தயாரிப்பு குறிச்சொற்கள்",
        "product_feedback": "தயாரிப்பு கருத்து",
        "inventory_thresholds": "இருப்பு வரம்புகள்",
        "seller_requests": "விற்பனையாளர் கோரிக்கைகள்",
        "buyer_dashboard": "வாங்குபவர் டாஷ்போர்டு",
        "my_orders": "எனது ஆர்டர்கள்",
        "cancellations": "நிச்சயதார்த்தங்கள்",
        "return_requests": "திரும்பப் பெறுதல் கோரிக்கைகள்",
        "personal_info": "தனிப்பட்ட தகவல்",
        "my_addresses": "எனது முகவரிகள்",
        "security": "பாதுகாப்பு",
        "reward_points": "வெகுமதி விபரங்கள்",
        "share_earn": "பகிரவும் மற்றும் சம்பாதிக்கவும்",
        "order_id": "ஆர்டர் ஐடி",
        "date": "தேதி",
        "scheduled": "திட்டமிடப்பட்டது",
        "action": "செயல்",
        "view": "பார்வை",
        "my_offers": "எனது சலுகைகள்",
        "my_credits": "எனது வரவுகள்",
        "notifications": "அறிவிப்புகள்",
        "contact_us": "எங்களைத் தொடர்பு கொள்ளுங்கள்",
        "view_all": "அனைத்தையும் பார்",
        "no_notifications": "புதிய அறிவிப்புகள் இல்லை",
        "shop": "கடை",
        "category": "வகையினம்",
        "brand": "பிராண்ட்",
        "user": "பயனர்",
        "customer": "வாடிக்கையாளர்",
        "delivery": "டெலிவரி",
        "product": "தயாரிப்பு",
        "price": "விலை",
        "total": "மொத்தம்",
        "amount": "தொகை",
        "revenue": "வருவாய்",
        "credits": "வரவுகள்",
        "wallet": "பணப்பை",
        "name": "பெயர்",
        "code": "குறியீடு",
        "default": "இயல்புநிலை",
        "system_default": "அமைப்பு இயல்புநிலை",
        "system_default_tooltip": "புதிய பயனர்கள் மற்றும் விருந்தினர்களுக்கான இயல்புநிலை",
        "standard": "தரநிலை",
        "language_name": "மொழி பெயர்",
        "language_code": "மொழி குறியீடு",
        "set_default_language": "இயல்புநிலை மொழியாக அமை",
        "active_status_label": "நிலை",
        "please_enter_name": "தயவுசெய்து பெயரை உள்ளிடவும்",
        "please_enter_code": "தயவுசெய்து குறியீட்டை உள்ளிடவும்",
        "confirm_delete_language": "இந்த மொழியை நீக்கவா?",
        "language_deleted": "மொழி வெற்றிகரமாக நீக்கப்பட்டது",
        "failed_delete_language": "மொழியை நீக்குவதில் தோல்வி",
        "language_updated": "மொழி வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
        "language_added": "மொழி வெற்றிகரமாக சேர்க்கப்பட்டது",
        "pending": "நிலுவையில்",
        "approved": "அங்கீகரிக்கப்பட்டது",
        "rejected": "நிராகரிக்கப்பட்டது",
        "active": "செயலில்",
        "inactive": "செயலற்றது",
        "active_status": "செயலில்",
        "processing": "செயலாக்கத்தில்",
        "shipped": "அனுப்பப்பட்டது",
        "delivered": "வழங்கப்பட்டது",
        "cancelled": "ரத்து செய்யப்பட்டது",
        "ordered": "ஆர்டர் செய்யப்பட்டது",
        "packed": "பேக் செய்யப்பட்டது",
        "completed": "முடிந்தது",
        "return_requested": "திரும்பக் கோரப்பட்டது",
        "return_picked_up": "எடுக்கப்பட்டது",
        "returned": "திரும்பப் பெறப்பட்டது",
        "refund_completed": "பணம் திரும்பப் பெறுதல் முடிந்தது",
        "delivery_missed": "டெலிவரி தவறவிட்டது",
        "more_items": "கூடுதல் பொருட்கள்",
        "success": "வெற்றி",
        "error": "பிழை",
        "confirm_delete": "நிச்சயமாக அழிக்க விரும்புகிறீர்களா?",
        "no_data": "தரவு இல்லை",
        "loading": "ஏற்றுகிறது...",
        "welcome": "வரவேற்கிறோம்",
        "application_status": "விண்ணப்ப நிலை",
        "latest_orders": "சமீபத்திய ஆர்டர்கள்",
        "available_balance": "கிடைக்கக்கூடிய இருப்பு",
        "credited_today": "இன்று வரவு வைக்கப்பட்டது",
        "order_stats": "ஆர்டர் புள்ளிவிவரங்கள்",
        "today_orders": "இன்றைய ஆர்டர்கள்",
        "unread_notification": "படிக்காத அறிவிப்பு",
        "invite_friends": "உங்கள் நண்பர்களை அழைக்கவும்!",
        "share_referral_text": "உங்கள் தனித்துவமான பரிந்துரை குறியீட்டை நண்பர்கள் மற்றும் குடும்பத்தினருடன் பகிர்ந்து கொள்ளுங்கள். அவர்கள் பதிவு செய்து முதல் முறை வாங்கும்போது புள்ளிகளைப் பெறுங்கள்.",
        "copy": "நகலெடு",
        "share": "பகிரவும்",
        "no_record_found": "தகவல் எதுவும் இல்லை",
        "address": "முகவரி",
        "track_returns": "திரும்பப் பெறுதல் கோரிக்கைகளை இங்கே கண்காணிக்கவும்.",
        "check_later": "தயவுசெய்து சிறிது நேரம் கழித்து மீண்டும் பார்க்கவும்.",
        "return_status": "திரும்பிய நிலை",
        "reason": "காரணம்",
        "seller_comment": "விற்பனையாளர் கருத்து",
        "request_summary": "கோரிக்கை சுருக்கம்",
        "refund_value": "பணம் திரும்பக் கிடைக்கும் மதிப்பு",
        "submitted": "சமர்ப்பிக்கப்பட்டது",
        "requested_items": "கோரப்பட்ட பொருட்கள்",
        "quantity": "அளவு",
        "close": "மூடு",
        "return_details": "திரும்பப் பெறுதல் கோரிக்கை விவரங்கள்",
        "request_id": "கோரிக்கை ஐடி",
        "sales_overview": "மாதாந்திர விற்பனை கண்ணோட்டம்",
        "live_data": "நேரடி தரவு",
        "no_recent_orders": "சமீபத்திய ஆர்டர்கள் இல்லை",
        "total_shops": "மொத்த கடைகள்",
        "total_products": "மொத்த தயாரிப்புகள்",
        "recent_orders_card": "சமீபத்திய ஆர்டர்கள்",
        "monthly_comparison": "கடந்த காலாண்டுடன் மாதவிடாய் செயல்திறன் ஒப்பீடு",
        "current_month": "நடப்பு மாதம்",
        "last_month": "கடந்த மாதம்",
        "quarter_target": "காலாண்டு இலக்கு",
        "growth": "வளர்ச்சி",
        "decline": "சரிவு",
        "compared_to_last_month": "கடந்த மாதத்துடன் ஒப்பிடும்போது",
        "delivery_missed_title": "டெலிவரி தவறிவிட்டது - நடவடிக்கைக்காக காத்திருக்கிறது",
        "delivery_missed_text": "உங்கள் திட்டமிடப்பட்ட டெலிவரி நேரத்தை நாங்கள் தவறவிட்டோம். தயவுசெய்து புதிய நேரத்தைத் தேர்வு செய்யவும் அல்லது உடனடி முழு பணத்தைத் திரும்பப் பெற ஆர்டரை ரத்து செய்யவும்.",
        "reschedule_now": "மீண்டும் திட்டமிடு",
        "other_orders": "ரத்துசெய்தல் மற்றும் திரும்பப் பெறுதல்",
        "crop_image": "படத்தை செதுக்கு",
        "zoom_label": "பெரிதாக்கு",
        "crop_failed": "படத்தை செதுக்குவதில் தோல்வி",
        "cancel_refund": "ரத்து செய்து பணத்தைத் திரும்பப் பெறு",
        "edit_profile": "சுயவிவரத்தைத் தொகுக்கவும்",
        "nearzon_user": "பயனர்",
        "personal_info_tab": "தனிப்பட்ட தகவல்",
        "my_addresses_tab": "எனது முகவரிகள்",
        "profile_settings_tab": "சுயவிவர அமைப்புகள்",
        "full_name": "முழு பெயர்",
        "email_address": "மின்னஞ்சல் முகவரி",
        "phone_number": "தொலைபேசி எண்",
        "joined_nearzon": "நியர்சனில் சேர்ந்தார்",
        "credit_balance": "வரவு இருப்பு",
        "saved_addresses": "சேமிக்கப்பட்ட முகவரிகள்",
        "add_address_btn": "முகவரியைச் சேர்",
        "add_new_address_btn": "புதிய முகவரியைச் சேர்",
        "security_settings": "பாதுகாப்பு அமைப்புகள்",
        "change_password": "கடவுச்சொல்லை மாற்றவும்",
        "privacy_settings": "தனியுரிமை அமைப்புகள்",
        "notification_settings": "அறிவிப்புகள்",
        "edit_personal_info": "தனிப்பட்ட தகவலைத் திருத்து",
        "save_changes": "மாற்றங்களைச் சேமி",
        "first_name": "முதல் பெயர்",
        "last_name": "குடும்பப் பெயர்",
        "email_unchangeable": "மின்னஞ்சலை மாற்ற முடியாது.",
        "update_profile_pic": "சுயவிவரப் படத்தை மாற்றவும்",
        "select_new_photo": "புதிய புகைப்படத்தைத் தேர்ந்தெடு",
        "upload_save": "பதிவேற்றி சேமி",
        "current_password": "தற்போதைய கடவுச்சொல்",
        "new_password": "புதிய கடவுச்சொல்",
        "confirm_new_password": "புதிய கடவுச்சொல்லை உறுதிப்படுத்தவும்",
        "passwords_do_not_match": "கடவுச்சொற்கள் பொருந்தவில்லை!",
        "show_profile_public": "சுயவிவரத்தை பொதுவில் காட்டு",
        "show_email_address": "மின்னஞ்சல் முகவரியைக் காட்டு",
        "show_phone_number": "தொலைபேசி எண்ணைக் காட்டு",
        "email_notifications": "மின்னஞ்சல் அறிவிப்புகள்",
        "order_status_updates": "ஆர்டர் நிலை புதுப்பிப்புகள்",
        "promotional_emails": "விளம்பர மின்னஞ்சல்கள்",
        "edit_address": "முகவரியைத் திருத்து",
        "add_new_address": "புதிய முகவரியைச் சேர்",
        "address_type": "முகவரி வகை",
        "street": "தெரு",
        "city_taluk": "நகரம்/தாலுகா",
        "district": "மாவட்டம்",
        "pincode": "பின்கோடு",
        "home_label": "வீடு",
        "office_label": "அலுவலகம்",
        "pickup_label": "பிக்கப்",
        "billing_label": "பில்லிங்",
        "other_label": "மற்றவை",
        "not_provided": "வழங்கப்படவில்லை",
        "na": "இல்லை",
        "retry": "மீண்டும் முயற்சி செய்",
        "security_config": "பாதுகாப்பு கட்டமைப்பு",
        "manage_security_desc": "உங்கள் கடவுச்சொல் மற்றும் பாதுகாப்பு கேள்விகளை நிர்வகிக்கவும்.",
        "no_addresses_found": "முகவரிகள் எதுவும் இல்லை",
        "available_credits_label": "கிடைக்கக்கூடிய வரவுகள்",
        "total_earned": "மொத்தம் சம்பாதித்தது",
        "total_spent": "மொத்தம் செலவிட்டது",
        "bonus_credits": "போனஸ் வரவுகள்",
        "refunds": "பணத்தைத் திரும்பப் பெறுதல்",
        "transaction_history": "பரிவர்த்தனை வரலாறு",
        "no_transactions_yet": "பரிவர்த்தனைகள் எதுவும் இல்லை",
        "times_count": "முறை",
        "description": "விளக்கம்",
        "type": "வகை",
        "mark_all_read": "அனைத்தையும் படித்ததாகக் குறிக்கவும்",
        "no_wishlist_msg": "உங்கள் விருப்பப்பட்டியல் காலியாக உள்ளது",
        "my_wishlist": "எனது விருப்பப்பட்டியல்",
        "remove": "நீக்கு",
        "order_now": "இப்போதே ஆர்டர் செய்",
        "cart": "வண்டி",
        "enter_first_name": "முதல் பெயரை உள்ளிடவும்",
        "enter_last_name": "குடும்பப் பெயரை உள்ளிடவும்",
        "enter_street": "தெரு முகவரியை உள்ளிடவும்",
        "enter_pincode": "பின்கோடை உள்ளிடவும்",
        "select_addr_type": "முகவரி வகையைத் தேர்ந்தெடுக்கவும்",
        "enter_custom_label": "தனிப்பயன் லேபிளை உள்ளிடவும்",
        "label_eg_school": "லேபிள் (எ.கா. பள்ளி, ஜிம்)",
        "label_eg_warehouse": "லேபிள் (எ.கா. கிடங்கு)",
        "enter_curr_pass": "தற்போதைய கடவுச்சொல்லை உள்ளிடவும்",
        "enter_new_pass": "புதிய கடவுச்சொல்லை உள்ளிடவும்",
        "confirm_new_pass": "புதிய கடவுச்சொல்லை உறுதிப்படுத்தவும்",
        "pass_min_6": "கடவுச்சொல் குறைந்தது 6 எழுத்துக்களைக் கொண்டிருக்க வேண்டும்",
        "please_enter_curr_pass": "தயவுசெய்து உங்கள் தற்போதைய கடவுச்சொல்லை உள்ளிடவும்",
        "please_enter_new_pass": "தயவுசெய்து உங்கள் புதிய கடவுச்சொல்லை உள்ளிடவும்",
        "please_confirm_new_pass": "தயவுசெய்து உங்கள் புதிய கடவுச்சொல்லை உறுதிப்படுத்தவும்",
        "security_settings_loaded": "பாதுகாப்பு அமைப்புகள் ஏற்றப்பட்டன.",
        "error_loading_profile": "சுயவிவரத்தை ஏற்றுவதில் தோல்வி",
        "error_loading_addresses": "முகவரிகளை ஏற்றுவதில் தோல்வி",
        "error_removing_address": "முகவரியை நீக்குவதில் தோல்வி",
        "address_removed": "முகவரி நீக்கப்பட்டது",
        "address_updated": "முகவரி புதுப்பிக்கப்பட்டது",
        "address_added": "முகவரி சேர்க்கப்பட்டது",
        "error_saving_address": "முகவரியைச் சேமிப்பதில் தோல்வி",
        "transactions": "பரிவர்த்தனைகள்",
        "profile_updated_success": "சுயவிவரம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
        "error_updating_profile": "சுயவிவரத்தைப் புதுப்பிப்பதில் தோல்வி",
        "invalid_file": "தவறான கோப்பு",
        "invalid_file_desc": "நீங்கள் JPG/PNG/WEBP கோப்புகளை மட்டுமே பதிவேற்ற முடியும்!",
        "file_too_large": "கோப்பு மிகப்பெரியது",
        "file_too_large_desc": "படம் 2MB க்கும் குறைவாக இருக்க வேண்டும்!",
        "profile_image_updated": "சுயவிவரப் படம் புதுப்பிக்கப்பட்டது",
        "image_upload_failed": "படம் பதிவேற்றுவதில் தோல்வி",
        "password_updated_success": "கடவுச்சொல் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
        "error_updating_password": "கடவுச்சொல்லைப் புதுப்பிப்பதில் தோல்வி",
        "privacy_settings_updated": "தனியுரிமை அமைப்புகள் புதுப்பிக்கப்பட்டன",
        "error_updating_privacy": "தனியுரிமை அமைப்புகளைப் புதுப்பிப்பதில் தோல்வி",
        "notify_settings_updated": "அறிவிப்பு முன்னுரிமைகள் புதுப்பிக்கப்பட்டன",
        "error_updating_notify": "அறிவிப்பு அமைப்புகளைப் புதுப்பிப்பதில் தோல்வி",
        "address_removed_success": "முகவரி வெற்றிகரமாக நீக்கப்பட்டது",
        "addresses_updated_success": "முகவரிகள் வெற்றிகரமாக புதுப்பிக்கப்பட்டன",
        "change_password_desc": "வலிமையான கடவுச்சொல் மூலம் உங்கள் கணக்கைப் பாதுகாக்கவும்",
        "privacy_settings_desc": "உங்கள் தெரிவுநிலை மற்றும் தரவைக் கட்டுப்படுத்தவும்",
        "notification_settings_desc": "உங்கள் விழிப்பூட்டல் முன்னுரிமைகளை நிர்வகிக்கவும்",
        "today_hot_deals": "இன்றைய சூடான சலுகைகள்",
        "weekly_hot_deals": "கூடுதல் சூடான சலுகைகள்",
        "filters": "வடிகட்டிகள்",
        "shop_name": "கடையின் பெயர்",
        "zipcode": "பின்கோடு",
        "shops": "கடைகள்",
        "view_shop": "கடையைப் பார்",
        "less": "குறைவாக",
        "more": "மேலும்",
        "products_you_may_like": "உங்களுக்குப் பிடிக்கக்கூடிய தயாரிப்புகள்",
        "shops_within": "சுற்றுவட்டாரக் கடைகள்",
        "weekly_deals": "இன்றைய சலுகைகள்",
        "recipes": "சமையல் குறிப்புகள்",
        "user_login": "பயனர் உள்நுழைவு",
        "search_placeholder": "தயாரிப்புகள், பிராண்டுகள் மற்றும் பலவற்றைத் தேடுங்கள்...",
        "choose_location": "இடத்தைத் தேர்வுசெய்க",
        "under_review": "பரிசீலனையில் உள்ளது",
        "appearance": "தோற்றம்",
        "my_account": "எனது கணக்கு",
        "my_wallet": "எனது பணப்பை",
        "start_selling": "விற்பனை செய்யத் தொடங்குங்கள்",
        "off": "தள்ளுபடி",
        "select_option": "விருப்பத்தைத் தேர்ந்தெடுக்கவும்",
        "add": "சேர்",
        "buy_now": "இப்போதே வாங்குங்கள்",
        "in_stock": "கையிருப்பில் உள்ளது",
        "out_of_stock": "கையிருப்பில் இல்லை",
        "login_required": "உள்நுழைவு தேவை",
        "login_to_add_to_cart_desc": "பொருட்களை வண்டியில் சேர்க்க தயவுசெய்து உள்நுழையவும்.",
        "login_to_proceed_checkout_desc": "பொருட்களை வாங்க தயவுசெய்து உள்நுழையவும்.",
        "all_categories": "அனைத்து பிரிவுகள்",
        "quick_links": "விரைவான இணைப்புகள்",
        "get_in_touch": "தொடர்பு கொள்ள",
        "newsletter": "செய்தி மடல்",
        "newsletter_desc": "சிறப்பு சலுகைகள் மற்றும் அறிவிப்புகளைப் பெற சந்தா செலுத்துங்கள்.",
        "all_rights_reserved": "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
        "all_categories_desc": "Nearzon வழங்கும் அனைத்து தயாரிப்புகளையும் கண்டறியவும்.",
        "view_products": "தயாரிப்புகளைப் பார்",
        "explore_range": "எங்களின் பரந்த அளவிலான",
        "verified_sellers": "உள்ளூர் விற்பனையாளர்களிடமிருந்து ஆராயுங்கள்.",
        "all_products": "அனைத்து தயாரிப்புகள்",
        "track_order": "ஆர்டரைக் கண்காணிக்க",
        "help_center": "உதவி மையம்",
        "feedback": "கருத்து",
        "email": "மின்னஞ்சல்",
        "no_shops_found": "உங்கள் அளவுகோல்களுடன் பொருந்தக்கூடிய கடைகள் எதுவும் கிடைக்கவில்லை.",
        "fresh_products_daily": "தினமும் புதிய தயாரிப்புகள்",
        "nearzon_marketplace": "Nearzon சந்தைப்பிடம்",
        "inspired_by_browsing": "உங்கள் உலாவல் வரலாற்றின் அடிப்படையில்",
        "refresh": "புதுப்பி",
        "reset_all": "அனைத்தையும் மீட்டமை",
        "rating": "மதிப்பீடு",
        "price_range": "விலை வரம்பு",
        "shop_by_categories": "வகைகளின்படி கடை",
        "order_details": "ஆர்டர் விவரங்கள்",
        "cancel_order_btn": "ஆர்டரை ரத்துசெய்",
        "reschedule_delivery_btn": "டெலிவரியை மீண்டும் திட்டமிடு",
        "return_order_btn": "ஆர்டரைத் திருப்பி அனுப்பு",
        "reorder_btn": "மீண்டும் ஆர்டர் செய்",
        "order_info": "ஆர்டர் தகவல்",
        "price_summary": "விலை சுருக்கம்",
        "items_subtotal": "பொருட்களின் துணை மொத்தம்",
        "delivery_charges": "டெலிவரி கட்டணங்கள்",
        "total_order_value": "மொத்த ஆர்டர் மதிப்பு",
        "wallet_credits_used": "பயன்படுத்தப்பட்ட பணப்பை வரவுகள்",
        "cod_payable_amount": "சிஓடி செலுத்த வேண்டிய தொகை",
        "amount_paid": "செலுத்தப்பட்ட தொகை",
        "reason_for_cancellation": "ரத்து செய்ததற்கான காரணம்",
        "ordered_by_mistake": "தவறுதலாக ஆர்டர் செய்யப்பட்டது",
        "found_better_price": "சிறந்த விலை கிடைத்தது",
        "delivery_too_long": "டெலிவரி நேரம் மிக அதிகம்",
        "changed_my_mind": "மனதை மாற்றிக்கொண்டேன்",
        "other": "மற்றவை",
        "request_return": "திரும்பக் கோரு",
        "return_item": "பொருளைத் திருப்பி அனுப்பு",
        "select_reason_for_return": "திரும்பப் பெறுவதற்கான காரணத்தைத் தேர்ந்தெடுக்கவும்",
        "dont_like_product": "எனக்கு இந்தத் தயாரிப்பு பிடிக்கவில்லை",
        "wrong_item_received": "தவறான பொருள் பெறப்பட்டது",
        "quality_issue": "தரக் குறைபாடு",
        "better_price_available": "குறைந்த விலையில் கிடைக்கிறது",
        "ordered_by_mistake_return": "தவறுதலாக ஆர்டர் செய்யப்பட்டது",
        "other_reason": "மற்றொரு காரணம்",
        "confirm_return": "திரும்பப் பெறுதலை உறுதிசெய்",
        "cancel_refund_btn": "ரத்துசெய்து பணத்தைப் பெறு",
        "confirm_cancel": "ஆம், ஆர்டரை ரத்துசெய்",
        "confirm_cancel_msg": "இந்த ஆர்டரை ரத்து செய்ய விரும்புகிறீர்களா?",
        "standard_delivery": "சாதாரண டெலிவரி",
        "today": "இன்று",
        "failed_save_address": "முகவரியைச் சேமிப்பதில் தோல்வி",
        "no_profile_data": "சுயவிவரத் தரவு எதுவும் இல்லை. உங்கள் இணைப்பைச் சரிபார்க்கவும்.",
        "items": "பொருட்கள்",
        "submit": "சமர்ப்பிக்கவும்",
        "delivery_time_change_requested": "டெலிவரி நேர மாற்றக் கோரிக்கை",
        "seller_requested_time_change": "விற்பனையாளர் டெலிவரி நேரத்தை மாற்றக் கோரியுள்ளார்:",
        "approve": "அங்கீகரி",
        "reject": "நிராகரி",
        "adjust_filters_desc": "உங்கள் வடிகட்டிகள் அல்லது தேடல் சொற்களை சரிசெய்ய முயற்சிக்கவும்",
        "clear_all_filters": "அனைத்து வடிகட்டிகளையும் அழி"
    }
};
